/* src/app/modules/ct-status/components/cts-gantry-init-event/cts-gantry-init-event.component.scss */
:host {
  display: flex;
  align-items: flex-end;
  flex-grow: 1;
  flex: 1;
}
.gantry-event-container {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 1400px) {
  .gantry-event-container .event-description {
    font-size: 0.7rem;
  }
  .gantry-event-container .event-timestamp sh-text {
    font-size: 0.8rem;
  }
}
.event-description {
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cts-event-type {
  height: 3rem;
  min-width: 7.2rem;
  width: 100%;
  border-radius: 0.5rem;
}
.body-cts-event {
  gap: 0.5em;
  display: flex;
  padding: 0.25rem;
  height: inherit;
  align-items: center;
}
.event-timestamp {
  display: flex;
  width: 5.5rem;
  gap: 0.5rem;
}
.event-timestamp sh-text {
  width: fit-content;
}
.event-timestamp sh-text {
  font-weight: 700;
}
/*# sourceMappingURL=cts-gantry-init-event.component.css.map */
